import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "k-colour-dot" }

import { toRef } from 'vue'

interface IProps {
  color: string
  size?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KColourDot' },
  __name: 'KColourDot',
  props: {
    color: {},
    size: { default: '16px' }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v36fafc2b": (sizeRef.value),
  "v506e75f7": (colorRef.value)
}))


const props = __props

const colorRef = toRef(() => props.color)
const sizeRef = toRef(() => props.size)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})